
/* injects from baggage-loader */

const moduleBlockOverlays = angular.module('services.layoutEditor.timemachine.acts', []);

moduleBlockOverlays.factory('TimeActs', [
    '$state', '$timeout', '$injector', 'ns', 'Section', 'SectionEmail', 'SectionWebForm', 'SectionLesson', '$rootScope', 'Animation',
    ($state, $timeout, $injector, ns, Section, SectionEmail, SectionWebForm, SectionLesson, $rootScope, Animation) => {
        let Y = void 0;

        if ($state.current.name === 'email.page.editor') {
            Section = SectionEmail;
        }

        if ($state.current.name === 'form.page.editor') {
            Section = SectionWebForm;
        }

        if ($state.current.name === 'lesson.page.editor') {
            Section = SectionLesson;
        }

        const timeacts = {
            init: function(y) {
                return Y = y;
            },
            addSectionAct: {
                undo: function(lastCapture) {
                    var editorDragPanel, section;
                    section = Y.one("[data-section-id='" + lastCapture.json.id + "']");
                    editorDragPanel = $injector.get("editorDragPanel");
                    editorDragPanel.removeSection(section, false);
                },
                redo: function(lastCapture) {
                    var blocksBuilder, editorDragPanel, editorNavSections, html, oldSection, path, sectionId, sectionType, tplWrapper;
                    blocksBuilder = $injector.get("blocksBuilder");
                    editorNavSections = $injector.get("editorNavSections");
                    editorDragPanel = $injector.get("editorDragPanel");
                    sectionId = lastCapture.json.id;
                    sectionType = lastCapture.json.section_type;
                    html = lastCapture.html;
                    path = lastCapture.path;
                    tplWrapper = Y.one(ns.tplContainer);
                    Section.restore(sectionId);
                    oldSection = blocksBuilder.createSection(ns.sectionLoader, sectionType);
                    switch (sectionType) {
                        case "default":
                            if (path) {
                                Y.one("[data-section-id='" + path + "']").insert(oldSection, "after");
                            } else {
                                Y.one(ns.dropBackdropClass).insert(oldSection, "after");
                            }
                            editorNavSections.removeDropBackdrop();
                            break;
                        case "header":
                            tplWrapper.prepend(oldSection);
                            break;
                        case "footer":
                            tplWrapper.append(oldSection);
                    }
                    editorNavSections.sectionInitializer(lastCapture.json, html, oldSection, false);
                    editorNavSections.bindSectionOnDropInTemplate(oldSection);
                    editorDragPanel.cancelSection();
                    $rootScope.toggleCommonSections();
                }
            },
            removeSectionAct: {
                undo: function(lastCapture) {
                    return timeacts.addSectionAct.redo(lastCapture);
                },
                redo: function(lastCapture) {
                    return timeacts.addSectionAct.undo(lastCapture);
                }
            },
            moveSectionAct: {
                undo: function(lastCapture) {
                    var originalSection, path, sectionDragDrop;
                    sectionDragDrop = $injector.get("sectionDragDrop");
                    originalSection = Y.one("[data-section-id=" + lastCapture.json + "]");
                    path = Y.one("[data-section-id=" + lastCapture.path + "]");
                    path.insert(originalSection, "after");
                    sectionDragDrop._afterDragEnd();
                    return Animation.scrollTo($(originalSection._node));
                },
                redo: function(lastCapture) {
                    var drop, originalSection, sectionDragDrop, y;
                    sectionDragDrop = $injector.get("sectionDragDrop");
                    originalSection = Y.one("[data-section-id=" + lastCapture.json + "]");
                    drop = Y.one("[data-section-id=" + lastCapture.html.drop + "]");
                    y = lastCapture.html.y;
                    drop.insert(originalSection, y);
                    sectionDragDrop._afterDragEnd();
                    return Animation.scrollTo($(originalSection._node));
                }
            },
            reInitSection: function(sectionEl) {
                var blockEditDialog, e, editorDragPanel;
                editorDragPanel = $injector.get("editorDragPanel");
                blockEditDialog = $injector.get("blockEditDialog");
                e = {
                    target: sectionEl
                };
                editorDragPanel.cancelSection();
                editorDragPanel._onClickEditSection(e, false);
                return Animation.scrollTo($(sectionEl._node));
            },
            updateSectionAct: {
                undo: function(lastCapture) {
                    var images, sectionEl, sectionId;
                    sectionId = lastCapture.json.oldSection.id;
                    sectionEl = Y.one("[data-section-id='" + sectionId + "']");
                    images = angular.copy(sectionEl.section.background_attributes.images_attributes);
                    sectionEl.section = lastCapture.json.oldSection;
                    sectionEl.section.background_attributes.images_attributes = images;
                    Section.saveSettings(lastCapture.json.oldSection);
                    return timeacts.reInitSection(sectionEl);
                },
                redo: function(lastCapture) {
                    var images, sectionEl, sectionId;
                    sectionId = lastCapture.json.newSection.id;
                    sectionEl = Y.one("[data-section-id='" + sectionId + "']");
                    images = angular.copy(sectionEl.section.background_attributes.images_attributes);
                    sectionEl.section = lastCapture.json.newSection;
                    sectionEl.section.background_attributes.images_attributes = images;
                    Section.saveSettings(lastCapture.json.newSection);
                    return timeacts.reInitSection(sectionEl);
                }
            },
            widgetsChangeAct: {
                undo: function(lastCapture) {
                    var layoutEditor, sectionEl, sectionElWrapper;
                    layoutEditor = $injector.get("layoutEditor");
                    sectionEl = Y.one("[data-section-id='" + lastCapture.json.oldJson.id + "']");
                    sectionElWrapper = sectionEl.one(ns.wrapperClass);
                    sectionElWrapper.all(ns.rowClass).remove();
                    sectionElWrapper.setContent(lastCapture.html.oldHtml);
                    layoutEditor.setJsonToRows(lastCapture.json.oldJson.structure.rows, sectionEl);
                    Section.save(sectionEl);
                    return timeacts.reInitSection(sectionEl);
                },
                redo: function(lastCapture) {
                    var layoutEditor, sectionEl, sectionElWrapper;
                    layoutEditor = $injector.get("layoutEditor");
                    sectionEl = Y.one("[data-section-id='" + lastCapture.json.newJson.id + "']");
                    sectionElWrapper = sectionEl.one(ns.wrapperClass);
                    sectionElWrapper.all(ns.rowClass).remove();
                    sectionElWrapper.setContent(lastCapture.html.newHtml);
                    layoutEditor.setJsonToRows(lastCapture.json.newJson.structure.rows, sectionEl);
                    Section.save(sectionEl);
                    return timeacts.reInitSection(sectionEl);
                }
            },
            resizeColAct: {
                undo: function(lastCapture) {
                    var blocksBuilder, leftCol, oldSizes, rightCol, sectionEl, widget, widgetId;
                    blocksBuilder = $injector.get("blocksBuilder");
                    widgetId = lastCapture.json.widgetId;
                    oldSizes = lastCapture.json.oldSizes;
                    widget = Y.one("[data-block-id='" + widgetId + "']");
                    sectionEl = widget.ancestor(ns.sectionClass);
                    Animation.scrollTo($(sectionEl._node));
                    leftCol = widget.ancestor(ns.colClass);
                    rightCol = leftCol.next();
                    blocksBuilder.updateColSize(leftCol, oldSizes[0]);
                    blocksBuilder.updateColSize(rightCol, oldSizes[1]);
                    return Section.save(sectionEl);
                },
                redo: function(lastCapture) {
                    var blocksBuilder, leftCol, newSizes, rightCol, sectionEl, widget, widgetId;
                    blocksBuilder = $injector.get("blocksBuilder");
                    widgetId = lastCapture.json.widgetId;
                    newSizes = lastCapture.json.newSizes;
                    widget = Y.one("[data-block-id='" + widgetId + "']");
                    sectionEl = widget.ancestor(ns.sectionClass);
                    Animation.scrollTo($(sectionEl._node));
                    leftCol = widget.ancestor(ns.colClass);
                    rightCol = leftCol.next();
                    blocksBuilder.updateColSize(leftCol, newSizes[0]);
                    blocksBuilder.updateColSize(rightCol, newSizes[1]);
                    return Section.save(sectionEl);
                }
            }
        };
        return timeacts;
    }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/timemachine/timeActs.js